import { TApisOfSchemas } from '../..';
import type ISchemas from './schemas';

const apis: TApisOfSchemas<ISchemas> = {
  checkRegistrationNationalCode: (input) => ({
    url: 'reg/anonymous/api/v1/users/request',
    method: 'POST',
    data: {
      nationalId: input?.nationalId,
    },
    params: {
      ...(input?.returnUrl ? { returnUrl: input.returnUrl } : {}),
      ...(input?.isChild ? { isChild: input.isChild } : {}),
    },
  }),
  sendPhoneOtp: (input) => ({
    url: 'reg/anonymous/api/v1/users/otp',
    method: 'POST',
    data: input,
  }),
  verifyOtp: (input) => ({
    url: 'reg/anonymous/api/v1/users/otp/verify',
    method: 'POST',
    data: input,
  }),
  verifySejamOtp: (input) => ({
    url: 'reg/anonymous/api/v1/sejam/kyc/profile',
    method: 'POST',
    data: input,
  }),
  SejamNumberNotAvailable: (input) => ({
    url: 'reg/anonymous/api/v1/sejam/mobile/noAccess',
    method: 'POST',
    data: input,
  }),
  finishRegister: (input) => ({
    url: 'reg/anonymous/api/v1/users/token',
    method: 'POST',
    data: input,
  }),
  getTestQuestions: (input) => ({
    url: 'reg/api/v1/contracts/TestContract',
    method: 'POST',
    data: input,
  }),
  submitTestResults: (input) => ({
    url: 'reg/api/v1/contracts/test',
    data: input,
    method: 'POST',
  }),
  getEContracts: (input) => ({
    url: 'reg/api/v1/contracts/eContract',
    method: 'POST',
    data: input,
  }),
  sendEContractOtp: (input) => ({
    url: 'reg/api/v1/contracts/eContract/Otp',
    data: input,
    method: 'POST',
  }),
  verifyEContractOtp: (input) => ({
    url: 'reg/api/v1/contracts/eContract/verify/Otp',
    data: input,
    method: 'POST',
  }),
  getRegNextStepStatus: (input) => ({
    url: 'reg/api/v1/users/status',
    data: input,
    method: 'POST',
  }),
  checkBirthDateValidation: (input) => ({
    url: 'reg/api/v1/users/InquiryBirthDate',
    data: input,
    method: 'POST',
  }),
  updateUserIdentity: (input) => ({
    url: 'reg/api/v1/users/UpdateIdentity',
    data: input,
    method: 'POST',
  }),
  continueWithInvalidShahkarNumber: (input) => ({
    url: 'reg/anonymous/api/v1/users/continueWithInvalidShahkar',
    data: input,
    method: 'POST',
  }),
  sendTraceCodeOtp: (input) => ({
    url: 'reg/anonymous/api/v1/sejam/traceCode/otp',
    method: 'POST',
    data: input,
  }),
  verifyTraceCodeOtp: (input) => ({
    url: 'reg/anonymous/api/v1/sejam/traceCode/profile',
    method: 'POST',
    data: input,
  }),
  getVideoAuthenticationSentence: () => ({
    url: `reg/api/v1/ekyc/text`,
    method: 'GET',
  }),
  uploadVideo: (input) => ({
    url: `reg/api/v1/ekyc/video`,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    method: 'POST',
    data: input,
  }),
  uploadSignature: (input) => ({
    url: `reg/api/v1/ekyc/signature`,
    method: 'POST',
    data: input,
  }),
  getAddressWithPostalCode: (input) => ({
    url: 'reg/api/v1/Contact/inquiry',
    method: 'POST',
    data: input,
  }),
  getBankDetailByAccountNumber: (input) => ({
    url: 'reg/api/v1/bankAccounts/inquiry',
    method: 'POST',
    data: input,
  }),
  getBankList: () => ({
    url: 'reg/api/v1/baseInfo/banks',
    method: 'GET',
  }),
  getProvinces: () => ({
    url: 'reg/api/v1/baseinfo/provinces',
    method: 'GET',
  }),
  getCountries: () => ({
    url: 'reg/api/v1/baseinfo/countries',
    method: 'GET',
  }),
  getProvincesByCountryId: (input) => ({
    url: `reg/api/v1/baseinfo/provinces/${input.countryId}`,
    method: 'GET',
  }),
  getCities: (input) => ({
    url: `reg/api/v1/baseinfo/Cities/${input.provinceId}`,
    method: 'GET',
  }),
  postAddress: (input) => ({
    url: 'reg/api/v1/Contact/address',
    method: 'POST',
    data: input,
  }),
  getAccountTypes: () => ({
    url: `reg/api/v1/baseInfo/account/types`,
    method: 'GET',
  }),
  getTradingLevels: () => ({
    url: `reg/api/v1/baseinfo/TradingLevels`,
    method: 'GET',
  }),
  getJobTitles: () => ({
    url: `reg/api/v1/baseinfo/JobsTitle`,
    method: 'GET',
  }),
  postContactInformation: (input) => ({
    url: 'reg/api/v1/Contact/EmailAndNumber',
    method: 'POST',
    data: input,
  }),
  saveBankAccountInfo: (input) => ({
    url: 'reg/api/v1/bankAccounts',
    method: 'POST',
    data: input,
  }),
  saveTradingLevelInfo: (input) => ({
    url: 'reg/api/v1/OtherInfo/TradingLevel',
    method: 'POST',
    data: input,
  }),
  getProfilingInfo: (input) => ({
    url: 'reg/api/v1/entrynode',
    method: 'POST',
    data: input,
  }),
  sendProfilingOtp: (input) => ({
    url: 'reg/api/v1/entrynode/otp',
    method: 'POST',
    data: input,
  }),
  verifyProfilingOtp: (input) => ({
    url: 'reg/api/v1/entrynode/otp/verify',
    method: 'POST',
    data: input,
  }),
  getProfilingNextStep: (input) => ({
    url: 'reg/api/v1/users/traceCodes/inquiry',
    method: 'POST',
    data: input,
  }),
  sendProfilingTraceCodeOtp: (input) => ({
    url: 'reg/api/v1/users/traceCodes/otp',
    method: 'POST',
    data: input,
  }),
  verifyProfilingTraceCodeOtp: (input) => ({
    url: 'reg/api/v1/users/traceCodes/otp/verify',
    method: 'POST',
    data: input,
  }),
  verifySerialNumber: (input) => ({
    url: 'reg/api/v1/ekyc/photo/inquiry',
    method: 'POST',
    data: input,
  }),
  ekycApproval: (input) => ({
    url: 'reg/api/v1/ekyc/inquiry',
    method: 'POST',
    data: input,
  }),
  sendProfileOtp: (input) => ({
    url: 'reg/api/v1/profile/otp',
    method: 'POST',
    data: input,
  }),
  verifyProfileOtp: (input) => ({
    url: 'reg/api/v1/profile/otp/verify',
    method: 'POST',
    data: input,
  }),
};

export default apis;
